import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { LocaleModule } from 'common/locale/module'

import { UtilCommonModule } from '../util/module'
import { FileConflictModalComponent } from './components/fileConflictModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LocaleModule.forChild(),
    UtilCommonModule,
    NgbModalModule,
    NgbTooltipModule,
  ],
  declarations: [
    FileConflictModalComponent,
  ],
})
export class UtilFileConflictModule { }

export {
  FileConflictService,
  FileConflictOptions,
  FileConflictBox,
} from './services/fileConflict.service'
